import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "./Button.js";
/** The longest question the field accepts (design-spec §2 Composer). */
export const COMPOSER_MAX_LENGTH = 4000;
/** Send's words while an answer is arriving (knowledge-page design-spec §6). */
export const COMPOSER_BUSY_LABEL = "Answering…";
export function Composer({ value, onChange, onSend, placeholder, disabled, busy = false, sendLabel = "Send" }) {
    const ready = !disabled && !busy && value.trim().length > 0;
    const send = () => {
        if (ready)
            onSend();
    };
    return (_jsx("form", { "data-composer-form": "", onSubmit: (event) => {
            event.preventDefault();
            send();
        }, 
        // knowledge-page design-spec §4.4: composer form padding `12px 20px 18px`.
        style: { margin: 0, padding: "var(--space-15) var(--space-25) 18px", flex: "none" }, children: _jsxs("div", { "data-composer": "", "data-disabled": disabled ? "" : undefined, style: {
                display: "flex",
                flexDirection: "column",
                gap: "var(--space-1)",
                background: disabled ? "var(--tone)" : "var(--float)",
                borderRadius: "var(--radius-panel)",
                boxShadow: disabled ? "none" : "0 0 0 var(--border-hairline) var(--line)",
                // knowledge-page design-spec §4.4: field box padding has no token.
                padding: "10px 10px 10px 14px",
            }, children: [_jsx("textarea", { "aria-label": "Question", "data-composer-field": "", maxLength: COMPOSER_MAX_LENGTH, rows: 2, value: value, placeholder: placeholder, disabled: disabled, onChange: (event) => onChange(event.target.value), onKeyDown: (event) => {
                        if (event.key !== "Enter" || event.shiftKey || event.nativeEvent.isComposing)
                            return;
                        event.preventDefault();
                        send();
                    }, style: {
                        display: "block",
                        width: "100%",
                        margin: 0,
                        padding: 0,
                        border: "none",
                        outline: "none",
                        background: "transparent",
                        resize: "none",
                        color: "var(--ink-1)",
                        fontFamily: "var(--font-sans)",
                        fontSize: "var(--type-body-size)",
                        // knowledge-page design-spec §3.3: 24px line, 48px to 144px field.
                        lineHeight: "24px",
                        minHeight: "48px",
                        maxHeight: "144px",
                        overflowY: "auto",
                        fieldSizing: "content",
                        cursor: disabled ? "default" : "text",
                    } }), _jsx("div", { style: { display: "flex", justifyContent: "flex-end" }, children: _jsx(Button, { variant: "primary", "data-composer-send": "", disabled: !ready, children: busy ? COMPOSER_BUSY_LABEL : sendLabel }) })] }) }));
}
